import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "el-picker-panel__body-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "el-picker-panel__sidebar"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "el-picker-panel__body" }
const _hoisted_5 = { class: "el-picker-panel__content el-date-range-picker__content is-left" }
const _hoisted_6 = { class: "el-date-range-picker__header" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "el-picker-panel__content el-date-range-picker__content is-right" }
const _hoisted_9 = { class: "el-date-range-picker__header" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_month_table = _resolveComponent("month-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-picker-panel el-date-range-picker", [{
      'has-sidebar': _ctx.$slots.sidebar || _ctx.hasShortcuts
    }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      (_ctx.hasShortcuts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcuts, (shortcut, key) => {
              return (_openBlock(), _createElementBlock("button", {
                key: key,
                type: "button",
                class: "el-picker-panel__shortcut",
                onClick: ($event: any) => (_ctx.handleShortcutClick(shortcut))
              }, _toDisplayString(shortcut.text), 9, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-d-arrow-left",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.leftPrevYear && _ctx.leftPrevYear(...args)))
            }),
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: !_ctx.enableYearArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableYearArrow }, "el-picker-panel__icon-btn el-icon-d-arrow-right"]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leftNextYear && _ctx.leftNextYear(...args)))
                }, null, 10, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(_ctx.leftLabel), 1)
          ]),
          _createVNode(_component_month_table, {
            "selection-mode": "range",
            date: _ctx.leftDate,
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDate,
            "range-state": _ctx.rangeState,
            "disabled-date": _ctx.disabledDate,
            onChangerange: _ctx.handleChangeRange,
            onPick: _ctx.handleRangePick,
            onSelect: _ctx.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onPick", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.unlinkPanels)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: !_ctx.enableYearArrow,
                  class: _normalizeClass([{ 'is-disabled': !_ctx.enableYearArrow }, "el-picker-panel__icon-btn el-icon-d-arrow-left"]),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rightPrevYear && _ctx.rightPrevYear(...args)))
                }, null, 10, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "el-picker-panel__icon-btn el-icon-d-arrow-right",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.rightNextYear && _ctx.rightNextYear(...args)))
            }),
            _createElementVNode("div", null, _toDisplayString(_ctx.rightLabel), 1)
          ]),
          _createVNode(_component_month_table, {
            "selection-mode": "range",
            date: _ctx.rightDate,
            "min-date": _ctx.minDate,
            "max-date": _ctx.maxDate,
            "range-state": _ctx.rangeState,
            "disabled-date": _ctx.disabledDate,
            onChangerange: _ctx.handleChangeRange,
            onPick: _ctx.handleRangePick,
            onSelect: _ctx.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onPick", "onSelect"])
        ])
      ])
    ])
  ], 2))
}